import { LLMInstructionTranslationDto } from "../../dto/llm-instructions/lm-instruction-translations.dto";
import { LLMInstructionTranslation } from "../../models/llm-instruction.model";

export class  LLMInstructionTranslationMapper {
  public static toModel(dto: LLMInstructionTranslationDto): LLMInstructionTranslation {
    return {
      languageId: dto.language_id,
      text: dto.text
    }
  }

  public static toDto(m: LLMInstructionTranslation): LLMInstructionTranslationDto {
    return {
      language_id: m.languageId,
      text: m.text
    }
  }
}
